import PropTypes from 'prop-types'

import {
  Box,
  Icon,
  Dialog,
  Heading,
  Text,
  Button,
  Link,
} from '@redriverpress/system'

export default function AccessDialog({ onOpenChange, open }) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Overlay />
      <Dialog.StyledContent>
        <Dialog.StyledTitle>
          <Heading as='h6' mb={0}>
            Subscribe for Full Access
          </Heading>
        </Dialog.StyledTitle>
        <Text>
          To save, customize, print, and share flashcards, please purchase
          a&nbsp;subscription.
        </Text>
        <Box my={4} display='flex' justifyContent='center'>
          <Button secondary mr={2} as='a' href='/sign_in'>
            <Icon icon='sign-in' pr={2} />
            Log In
          </Button>
          <Button as='a' href='/pricing'>
            <Icon icon='plus' pr={2} />
            Sign Up
          </Button>
        </Box>
        <Box textAlign='center' mb={3}>
          <Link fontWeight={600} color='black' href='/tour/flashcards'>
            Learn about Flashcards
          </Link>
        </Box>
      </Dialog.StyledContent>
    </Dialog.Root>
  )
}

AccessDialog.propTypes = {
  onOpenChange: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
}
